import styled from "styled-components"

export const Style404 = styled.div`
.image-container-404{
	display:grid;
	place-items:center;
	width: 100%;
	height: 100vh;
	margin: 0;
	padding: 0;
}

.image-container-404 img{
		display:inline-block;
		width:500px;
		max-width:80vw;
}
`